export function formatarDataBrasilia(isoDate: string): string {
  const data = new Date(isoDate);
  data.setHours(data.getHours() - 3);
  const dataFormatada = data.toLocaleDateString("pt-BR");
  const horaFormatada = data.toLocaleTimeString("pt-BR", {
    hour: "2-digit",
    minute: "2-digit",
  });
  return `${dataFormatada} ${horaFormatada}`;
}
